import { Draft } from "immer";
import { get, PropertyPath, set } from "lodash";
import { Updater } from "use-immer";

export const createPathUpdater = <T>(
  setState: (updater: (draft: Draft<any>) => void) => void,
  path: PropertyPath,
): Updater<T> => {
  return (arg: T | ((draft: Draft<T>) => void)) => {
    setState((draft) => {
      if (typeof arg === "function") {
        // Für Function-Updates: erst den aktuellen Wert holen, dann die Funktion anwenden
        const currentValue = get(draft, path);
        const tempDraft = currentValue as Draft<T>;
        (arg as (draft: Draft<T>) => void)(tempDraft);
        set(draft as object, path, tempDraft);
      } else {
        // Für direkte Werte: einfach setzen
        set(draft as object, path, arg);
      }
    });
  };
};
